export const accommodationFacilities = {
  ACCOMMODATION_FACILITIES_COLLAPSE: 'accommodationFacilities.collapse'
}
